document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartNote', () => {
    return {
      updating: false,
      // What the cart is known to hold, so a flush on the way out can tell "already saved" from
      // "typed but never sent" without asking the server.
      lastSent: null,

      init() {
        this.lastSent = this.$root.value;

        // The note is saved 750ms after typing stops, or on blur. A shopper who types their message
        // and goes straight to Check Out inside that window sends nothing, and their words stay on
        // screen, so they believe we have them. Flush on the way out as well. `keepalive` is what
        // makes this work where the plain fetch could not: the request outlives the navigation
        // instead of being cancelled by it.
        const flush = () => {
          if (this.$root.value === this.lastSent) return;
          this.send(true);
        };

        const form = this.$root.closest('form');
        if (form) form.addEventListener('submit', flush, true);

        // The cart drawer's checkout control is not always inside this form, and the cart page can
        // re-render this section under us, so the click is caught on the document in the capture
        // phase rather than bound to one button.
        document.addEventListener(
          'click',
          (event) => {
            const el = event.target;
            if (!el || typeof el.closest !== 'function') return;
            if (el.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]')) flush();
          },
          true
        );
      },

      updateNote() {
        this.send(false);
      },

      send(keepalive) {
        const value = this.$root.value;
        if (!keepalive) this.updating = true;
        return fetch(theme.routes.cart_update_url, {
          method: 'POST',
          keepalive: Boolean(keepalive),
          body: JSON.stringify({
            note: value,
          }),
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;',
            Accept: 'application/json',
          },
        }).then(() => {
          this.lastSent = value;
          this.updating = false;
        });
      },
    };
  });
});
